import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AppConfiguration, configurationContext } from "./config";
import { DevConfigPanel } from "../Components";
import { useGlobalAppConfig } from "..";

interface Props {
    children: React.ReactNode;
}

export const AppConfigurationContext: React.FC<Props> = ({ children }) => {
    const globalConfig = useGlobalAppConfig();
    const [apiConfig, setApiConfig] = useState<AppConfiguration>({ apiConfiguration: globalConfig.apiConfig });
    const [searchParams] = useSearchParams();
    const devSearchParam = searchParams.get("dev");
    const devMode = devSearchParam !== "false" && globalConfig.env !== "production";

    return (
        <configurationContext.Provider value={{ config: apiConfig, setConfig: setApiConfig }}>
            {children}
            {devMode && <DevConfigPanel />}
        </configurationContext.Provider>
    );
};
